import { modifier } from 'ember-modifier';

function registerElement(element, [callback]) {
  callback(element);
}

export default modifier(registerElement, {
  eager: false
});